import { render, staticRenderFns } from "./MoveBehind.vue?vue&type=template&id=7b994222&scoped=true&"
var script = {}
import style0 from "./MoveBehind.vue?vue&type=style&index=0&id=7b994222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b994222",
  null
  
)

export default component.exports